import React from 'react';
import assign from 'object-assign';
import _ from 'underscore';
import { FormControl } from 'react-bootstrap';
function userFormMixin(Component) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                errors: [],
            };
        }
        getStateFromProps(newProps) {
            const state = {};
            const props = newProps || this.props;
            _.keys(props.details).forEach((key) => {
                state[key] = props.details[key];
            });
            return state;
        }
        getInputValue(name) {
            return _.extend({}, this.state, name);
        }
        getErrorMessage(fieldName, label) {
            const message = `${label} is not valid.`;
            if (!this.validation || !this.validation[fieldName])
                return message;
            return this.validation[fieldName].message || message;
        }
        getError(fieldName, label) {
            let found = false;
            let i = 0;
            let error;
            if (!this.state.errors)
                return false;
            while (!found && i < this.state.errors.length) {
                i += 1;
                error = this.state.errors[i];
                if (error.field === fieldName)
                    found = error;
            }
            if (found)
                return this.getErrorMessage(fieldName, label);
            return false;
        }
        getFieldValidation(fieldName) {
            if (!this.validation || !this.validation[fieldName])
                return false;
            return this.validation[fieldName].test;
        }
        /**
         * Update the state to reflect the input change.
         * Deep change in the state is possible using points in the
         * input name. You can update the month of { date: {day: 1, month: 10} }
         * creating the input with the name 'date.month'
         *
         * @param  {Event} e The change event.
         */
        updateField(e) {
            const target = e.target;
            const nameParts = e.target.name.split('.');
            const update = assign({}, this.state);
            let stateTarget = update;
            let value = target.value;
            let i = 0;
            if (target.type === 'checkbox')
                value = target.checked;
            while (i < nameParts.length - 1) {
                i += 1;
                stateTarget = stateTarget[nameParts[i]];
            }
            // The worlds dumbest hack
            if (nameParts[nameParts.length - 1] === 'markup' && value > 0.3) {
                value = 0.3;
            }
            stateTarget[nameParts[nameParts.length - 1]] = value;
            this.setState(update);
        }
        renderInput(name, label, input, extraClass) {
            let className = `userDetailField userDetailField_ control-label' ${name}`;
            let errorMessage = '';
            const error = this.getError(name, label);
            const validation = this.getFieldValidation(name);
            if (extraClass)
                className += ` ${extraClass}`;
            if (validation)
                input.props['data-validation'] = validation;
            if (error) {
                className += ' userDetailFieldError';
                errorMessage = React.createElement("div", { className: "userDetailError" }, error);
            }
            return (React.createElement("div", { className: "form-group" },
                React.createElement("label", { className: className, style: { width: '100%' } },
                    React.createElement("div", { className: "userDetailLabel" }, label),
                    React.createElement("div", { className: "userDetailValue" },
                        input,
                        errorMessage))));
        }
        renderTextInput(name, label, attrs, markupCB) {
            const extra = attrs || {};
            const self = this;
            const changeHandler = (e) => {
                self.updateField(e);
                markupCB && markupCB(self.state.markup);
            };
            const input = (React.createElement(FormControl, Object.assign({}, extra, { type: "text", name: name, value: this.getInputValue(name), onChange: (e) => this.updateField(e) })));
            return this.renderInput(name, label, input, 'userDetailInput');
        }
        renderPasswordInput(name, label, extra = {}) {
            const input = (React.createElement("input", Object.assign({}, extra, { type: "password", name: name, value: this.getInputValue(name), onChange: (e) => this.updateField(e) })));
            return this.renderInput(name, label, input, 'userDetailPassword');
        }
        renderCheckbox(name, label, onChange, extra = {}) {
            const input = (React.createElement("input", Object.assign({}, extra, { type: "checkbox", name: name, checked: this.getInputValue(name), onChange: onChange || ((e) => this.updateField(e)) })));
            return this.renderInput(name, label, input, 'userDetailCheckbox');
        }
        /**
         * Renders a select box.
         * @param  {String} name    Name for the field
         * @param  {String} label   Text to be displayed beside the field
         * @param  {Array|Object} options Values for the selectbox. Can be an array of values or a
         *                                object with {value: label}
         * @return {ReactComponent}       The rendered selectBox
         */
        renderSelect(name, label, options, onSelect) {
            let values = options;
            // Ops must be an object {value: label}
            if (Array.isArray(values)) {
                values = {};
                options.forEach((op) => {
                    values[op] = op;
                });
            }
            const selectOptions = [];
            _.keys(values).forEach((val) => {
                selectOptions.push(React.createElement("option", { key: val, value: val }, values[val]));
            });
            const input = (React.createElement("select", { className: "form-select", name: name, value: this.state[name], onChange: onSelect || ((e) => this.updateField(e)) }, selectOptions));
            return this.renderInput(name, label, input, 'userDetailSelect');
        }
        render() {
            return (React.createElement(Component, Object.assign({}, this.props, { getStateFromProps: (newProps) => this.getStateFromProps(newProps), getInputValue: (name) => this.getInputValue(name), getErrorMessage: (fieldName, label) => this.getErrorMessage(fieldName, label), getError: (fieldName, label) => this.getError(fieldName, label), getFieldValidation: (fieldName) => this.getFieldValidation(fieldName), updateField: (e) => this.updateField(e), renderInput: () => this.renderInput(), renderTextInput: (name, label, input, extraClass) => this.renderTextInput(name, label, input, extraClass), renderPasswordInput: (name, label, extra) => this.renderPasswordInput(name, label, extra), renderCheckbox: (name, label, onChange, extra) => this.renderCheckbox(name, label, onChange, extra), renderSelect: (name, label, options, onSelect) => this.renderSelect(name, label, options, onSelect) })));
        }
    };
}
export default userFormMixin;
